export const resolveTenantBranchLimit = subscription => {
  const plan = subscription?.planId || subscription?.plan || {}
  return Number(plan?.maxBranches || 0)
}

export const isBranchLimitReached = (currentCount, maxBranches) =>
  maxBranches > 0 && Number(currentCount) >= maxBranches

export const getBranchLimitExceededMessage = (maxBranches, t) =>
  t(
    Number(maxBranches) === 1
      ? "Your current plan allows a maximum of {{max}} branch."
      : "Your current plan allows a maximum of {{max}} branches.",
    { max: maxBranches }
  )
